import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Flex,
  Image,
  Input,
  Modal,
  PaginationProps,
  Select,
  Table,
  TableColumnsType,
} from "antd";
import { ArrowSquareDown, Clock, Crown, SearchZoomIn1 } from "iconsax-react";
import "./DasTotalStoreModal.scss";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
// import tableData from '../playersTableData.json'
import { mixPostV1 } from "../../../services/mixin";
import { IMAGE_URL } from "../../../env";

const fallbackAvatar =
  "data:image/png;base64,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";

interface Props {
  isShow?: boolean;
  typeStore?: number;
  onPopupClose?: () => void;
}

const closeIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {" "}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.86312 3.86363C4.03189 3.6949 4.26077 3.60012 4.49942 3.60012C4.73806 3.60012 4.96694 3.6949 5.13572 3.86363L8.99942 7.72733L12.8631 3.86363C12.9461 3.77767 13.0455 3.7091 13.1553 3.66194C13.2651 3.61477 13.3832 3.58994 13.5027 3.5889C13.6222 3.58786 13.7407 3.61063 13.8513 3.65589C13.9619 3.70114 14.0624 3.76797 14.1469 3.85247C14.2314 3.93697 14.2982 4.03746 14.3435 4.14807C14.3887 4.25867 14.4115 4.37719 14.4104 4.49669C14.4094 4.61619 14.3846 4.73429 14.3374 4.84409C14.2902 4.95389 14.2217 5.0532 14.1357 5.13623L10.272 8.99993L14.1357 12.8636C14.2997 13.0334 14.3904 13.2607 14.3883 13.4967C14.3863 13.7327 14.2916 13.9584 14.1248 14.1253C13.9579 14.2921 13.7322 14.3868 13.4962 14.3888C13.2602 14.3909 13.0329 14.3002 12.8631 14.1362L8.99942 10.2725L5.13572 14.1362C4.96598 14.3002 4.73863 14.3909 4.50266 14.3888C4.26668 14.3868 4.04095 14.2921 3.87408 14.1253C3.70721 13.9584 3.61256 13.7327 3.61051 13.4967C3.60846 13.2607 3.69918 13.0334 3.86312 12.8636L7.72682 8.99993L3.86312 5.13623C3.69439 4.96745 3.59961 4.73857 3.59961 4.49993C3.59961 4.26128 3.69439 4.0324 3.86312 3.86363Z"
      fill="#6B7280"
    />{" "}
  </svg>
);

interface DataType {
  key: React.Key;
  store_id: number;
  store_name: string;
  type_name: string;
  owner_name: string;
  seller_name: string;
  create_at: string;
  is_expired: number;
  status_name: string;
  status: number;
  type_id: number;
}

const customPrevNext: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement,
) => {
  if (type === "prev") {
    return (
      <Flex align="center" gap={8}>
        <ArrowLeftOutlined />
        <span>Previous</span>
      </Flex>
    );
  }
  if (type === "next") {
    return (
      <Flex align="center" gap={8}>
        <span>Next</span>
        <ArrowRightOutlined />
      </Flex>
    );
  }
  return originalElement;
};

const DasTotalStoreModal: React.FC<Props> = (props) => {
  const { isShow = false, onPopupClose, typeStore = 0 } = props;
  const [searchTimeout, setSearchTimeout] = useState<any>(null);
  const [open, setOpen] = useState(isShow);

  useEffect(() => {
    setOpen(isShow);

    if (isShow) {
      getItems();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShow]);

  const onClose = () => {
    setOpen(false);
    setParams({
      ...params,
      page_number: 1,
      searchKey: "",
    });
    if (onPopupClose) {
      onPopupClose();
    }
  };

  const columns: TableColumnsType<DataType> = [
    {
      title: "No.",
      key: "stt",
      width: 70,
      align: "center",
      render: (_: any, __: any, index: number) =>
        (params.page_number - 1) * params.limit + index + 1,
    },
    {
      title: "Store ID",
      dataIndex: "store_id",
      key: "store_id",
    },
    {
      title: "Store Name",
      dataIndex: "store_name",
      key: "store_name",
    },
    {
      title: "Type",
      dataIndex: "type_name",
      key: "type_name",
      render: (type_id, record) => (
        // <Badge status={storeType(type_id).color} text={ record.type_name } className='rs-badge background' />
        <Badge
          status={record.type_id === 1 ? "warning" : "default"}
          text={record.type_name}
          className="rs-badge background"
        />
      ),
    },
    {
      title: "Status",
      dataIndex: "status_name",
      key: "status_name",
      render: (status, record) => {
        let className = "status-active";
        let text = record.status_name;
        if (record.status === 5) {
          className = "status-unpaid";
          text = "Rejected";
        } else if (record.is_expired === 2) {
          className = "status-warning";
          text = "Due soon";
        } else if (record.is_expired === 3) {
          className = "status-unpaid";
          text = "Unpaid";
        } else if (record.is_expired === 0) {
          className = "status-active";
          text = "Active";
        }
        return (
          <span className={`title-15 font-medium value ${className}`}>
            {text}
          </span>
        );
      },
    },
    {
      title: "Owner name",
      dataIndex: "owner_name",
      key: "owner_name",
    },
    {
      title: "Seller name",
      dataIndex: "seller_name",
      key: "seller_name",
    },
    {
      title: "Created date",
      dataIndex: "create_at",
      key: "create_at",
    },
  ];

  // GET PLAYERS
  const [items, setItems] = useState({
    list: [],
    total: 0,
  });
  const [tableLoading, setTableLoading] = useState(false);

  const [params, setParams] = useState<{
    limit: number;
    page_number: number;
    searchKey?: string;
  }>({
    limit: 15,
    page_number: 1,
    searchKey: "",
  } as any);

  const getItems = async () => {
    setTableLoading(true);

    try {
      const apiParams = {
        ...params,
        typeStore,
      } as any;
      console.log(apiParams);

      const res = await mixPostV1(
        "/api/webAdmin/gListStoreDashboardOwnerByType.php",
        apiParams,
      );

      if (res.status === 1) {
        setTableLoading(false);
        const result: any = [];
        res.data.map((item: any, index: any) =>
          result.push({
            ...item,
            key: `${item.store_id}-${index}`,
            store_id: item.store_id,
            store_name: item.store_name,
            type_name: item.type_name,
            owner_name: item.owner_name,
            seller_name: item.seller_name,
            create_at: item.create_at,
            is_expired: item.is_expired,
            status_name: item.status_name,
            type_id: item.type_id,
            status: item.status,
          }),
        );
        setItems({
          list: result,
          total: res.total,
        });
      }
    } catch (error) {}
  };
  const onPageChange = (page: number) => {
    setParams({
      ...params,
      page_number: page,
    });
  };

  const onTableChange = (data: any) => {
    setParams({
      ...params,
      page_number: data.current,
      limit: data.pageSize,
    });
  };

  const onSearch = (e: any) => {
    setParams({
      ...params,
      page_number: 1,
      searchKey: e.target.value,
    });
  };
  const onChange = (e: any) => {
    clearTimeout(searchTimeout);
    const timeout = setTimeout(() => {
      onSearch(e);
    }, 250);
    setSearchTimeout(timeout);
  };
  useEffect(() => {
    if (open) {
      getItems();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  // END SHIFT CHANGE

  return (
    <Modal
      centered
      open={open}
      closeIcon={closeIcon}
      footer={null}
      className="rs-modal das-total-match-modal"
      rootClassName="rs-modal-root"
      onCancel={onClose}
    >
      <div className="title-mix">List store</div>
      <div className="table-filter-block">
        <Input
          placeholder="Search by store name"
          prefix={<SearchZoomIn1 size={20} variant="Bulk" />}
          allowClear
          className="rs-input table-filter-block__search"
          onChange={(e) => onChange(e)}
          onPressEnter={(e) => onSearch(e)}
        />
      </div>

      <Table
        columns={columns}
        dataSource={items.list}
        className="rs-table table-text-nowrap match-height"
        loading={tableLoading}
        scroll={{
          x: true,
        }}
        pagination={{
          current: params.page_number,
          pageSize: params.limit,
          position: ["bottomCenter"],
          showSizeChanger: true,
          showTitle: false,
          total: items.total,
          itemRender: customPrevNext,
          onChange: (e) => onPageChange(e),
        }}
        onChange={onTableChange}
      />
    </Modal>
  );
};

export default DasTotalStoreModal;
